import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg, some } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { list_type, class_type, option_type, obj_type, string_type, equals } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { CreditCheckDTO$reflection } from "../CustomerContract/Common.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { ValidatedUrlModule_value, addClientReference, getCsrfEnabledRequest, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Http_send, Http_request, Http_method, Http_content, Http_withCredentials } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod, BodyContent } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { CreateInvoiceeDTO$reflection } from "./Model.js";

export function loadCreditCheck(clientNr, threeLetterCountryCode, orgNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/credit_check/%i/%s/%s"))(clientNr)(threeLetterCountryCode)(orgNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const record = some({});
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(CreditCheckDTO$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(CreditCheckDTO$reflection(), arg_3, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(obj_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(record));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function loadExistingInvoicee(clientNr, threeLetterCountryCode, orgNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/invoicee/%i/%s/%s"))(clientNr)(threeLetterCountryCode)(orgNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(class_type("System.Int64")), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(class_type("System.Int64")), arg_3, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(class_type("System.Int64")), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function saveNewInvoicee(clientNr, threeLetterCountryCode, orgNr, createInvoiceeJson) {
    let arg_1;
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, (arg_1 = threeLetterCountryCode.trim(), toText(printf("/invoicee/%i/%s/%s"))(clientNr)(arg_1)(orgNr))));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(2), new CaseStrategy(0));
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(class_type("System.Int64"), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(class_type("System.Int64"), arg_3, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(CreateInvoiceeDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(createInvoiceeJson));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

